import React, { useEffect, useState } from "react";
import { api, formatErr } from "../../lib/api";
import { toast } from "sonner";

const FIELDS = [
  { name: "site_name", label: "Nama Situs" },
  { name: "tagline", label: "Tagline" },
  { name: "contact_email", label: "Email Kontak" },
  { name: "contact_phone", label: "Telepon" },
  { name: "address", label: "Alamat" },
  { name: "about", label: "Tentang Kami", textarea: true },
  { name: "company_profile", label: "Profil Perusahaan", textarea: true },
  { name: "social_instagram", label: "Instagram URL" },
  { name: "social_facebook", label: "Facebook URL" },
  { name: "social_linkedin", label: "LinkedIn URL" },
  { name: "hero_title", label: "Judul Hero Utama" },
  { name: "hero_subtitle", label: "Subjudul Hero Utama", textarea: true },
  { name: "hero_image", label: "Gambar Hero Utama", isImage: true },
];

const API_FIELDS = [
  { name: "resend_api_key", label: "Resend API Key", desc: "Untuk email notifikasi (re_xxx)" },
  { name: "stripe_api_key", label: "Stripe Secret Key", desc: "Untuk pembayaran internasional (sk_xxx)" },
  { name: "xendit_api_key", label: "Xendit API Key", desc: "Untuk pembayaran lokal (xnd_xxx)" },
  { name: "midtrans_server_key", label: "Midtrans Server Key", desc: "Untuk pembayaran lokal" },
];

export default function AdminSettings() {
  const [form, setForm] = useState({});
  const [saving, setSaving] = useState(false);
  const [uploading, setUploading] = useState(false);

  useEffect(() => { api.get("/admin/settings").then(r => setForm(r.data || {})); }, []);

  const handleUpload = async (e, fieldName) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setUploading(true);
    const fd = new FormData();
    fd.append("file", file);
    try {
      const { data } = await api.post("/admin/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
      setForm(prev => ({ ...prev, [fieldName]: data.url }));
      toast.success("Foto berhasil diunggah");
    } catch (err) {
      toast.error("Gagal mengunggah foto");
    } finally {
      setUploading(false);
    }
  };

  const save = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const payload = {};
      [...FIELDS, ...API_FIELDS].forEach(f => {
        if (form[f.name] !== undefined && form[f.name] !== "") payload[f.name] = form[f.name];
      });
      await api.put("/admin/settings", payload);
      toast.success("Pengaturan disimpan");
    } catch (err) { toast.error(formatErr(err.response?.data?.detail)); }
    finally { setSaving(false); }
  };
  return (
    <div data-testid="admin-settings-page">
      <h1 className="font-serif text-4xl text-[#1A1728] mb-2">Pengaturan</h1>
      <p className="text-[#5C5870] mb-8">Informasi situs & integrasi</p>
      <form onSubmit={save} className="space-y-8 max-w-3xl">
        <div className="lumina-card p-7">
          <h2 className="font-serif text-2xl mb-5">Informasi Umum</h2>
          <div className="space-y-4">
            {FIELDS.map(f => (
              <div key={f.name}>
                <label className="lumina-label block mb-2">{f.label}</label>
                {f.isImage ? (
                  <div className="space-y-3">
                    {form[f.name] && (
                      <img src={form[f.name]?.startsWith("/") ? (process.env.REACT_APP_BACKEND_URL || "") + form[f.name] : form[f.name]} alt="Preview" className="w-full h-48 object-cover rounded-xl" />
                    )}
                    <input type="file" accept="image/*" disabled={uploading} onChange={(e) => handleUpload(e, f.name)} className="w-full text-sm file:mr-4 file:py-2.5 file:px-4 file:rounded-full file:border-0 file:text-sm file:font-semibold file:bg-[#F1EBFA] file:text-[#6B4BA3] hover:file:bg-[#E8F0FA] cursor-pointer border border-[#E2DFED] rounded-xl p-2" />
                  </div>
                ) : f.textarea ? (
                  <textarea rows={3} value={form[f.name] ?? ""} onChange={e=>setForm({...form,[f.name]:e.target.value})} className="w-full px-4 py-2.5 rounded-xl border border-[#E2DFED] focus:border-[#6B4BA3] outline-none" />
                ) : (
                  <input value={form[f.name] ?? ""} onChange={e=>setForm({...form,[f.name]:e.target.value})} className="w-full px-4 py-2.5 rounded-xl border border-[#E2DFED] focus:border-[#6B4BA3] outline-none" data-testid={`setting-${f.name}`} />
                )}
              </div>
            ))}
          </div>
        </div>

        <div className="lumina-card p-7">
          <h2 className="font-serif text-2xl mb-2">Integrasi API Keys</h2>
          <p className="text-sm text-[#5C5870] mb-5">Masukkan API key untuk mengaktifkan integrasi. Disimpan dengan aman di server.</p>
          <div className="space-y-4">
            {API_FIELDS.map(f => (
              <div key={f.name}>
                <label className="lumina-label block mb-2">{f.label}</label>
                <input type="password" placeholder="(belum dipasang)" value={form[f.name] ?? ""} onChange={e=>setForm({...form,[f.name]:e.target.value})} className="w-full px-4 py-2.5 rounded-xl border border-[#E2DFED] focus:border-[#6B4BA3] outline-none font-mono" data-testid={`key-${f.name}`} />
                <p className="text-xs text-[#5C5870] mt-1">{f.desc}</p>
              </div>
            ))}
          </div>
        </div>

        <button disabled={saving} className="lumina-btn-primary" data-testid="save-settings-btn">{saving ? "Menyimpan…" : "Simpan Pengaturan"}</button>
      </form>
    </div>
  );
}
